import { useMonitor } from './useMonitor'

export interface Event {
  event: string
  data?: Record<string, unknown>
}
export interface ErrorEvent extends Event {
  event: string
  error?: Error
  data?: Record<string, unknown>
}

export const useEventTracking = (group: string, event?: unknown) => {
  const awsRumClient = useMonitor()

  const trackError = (props: ErrorEvent) => {
    props.error ??= new Error('Message: Something went wrong')
    props.error.message = `Group: ${group} - ${props.error.message} - Event: "${getEvent(props.event)}"`
    awsRumClient.recordError(props.error)
  }
  const trackEvent = (props: Event) => {
    awsRumClient.recordEvent(props.event, { ...props.data })
  }

  return { trackEvent, trackError }
}

const getEvent = (title: string) => `Students - ${title}`
